import { useNewJoinersAndAllocationsInvestorsController } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/NewJoinersAndAllocationsModal/NewJoinersAndAllocationsStepsComponents/NewJoinersAndAllocationsInvestors/useNewJoinersAndAllocationsInvestorsController';
import { DragAndDrop } from '@dealstack/frontend/shared/components/DragAndDrop/DragAndDrop';
import { InvestorsUploadInstructions } from '@dealstack/frontend/shared/components/InvestorsUploadInstructions/InvestorsUploadInstructions';
import { Expandable } from '@dealstack/frontend/shared/components/Expandable/Expandable';
import { useTranslationMipCreate } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import styled from 'styled-components';

import { NewJoinersAndAllocationsInvestorsSummary } from './NewJoinersAndAllocationsInvestorsSummary';
import { NewJoinersAndAllocationsInvestorsTable } from './NewJoinersAndAllocationsInvestorsTable/NewJoinersAndAllocationsInvestorsTable';
import { EXCEL_SPREADSHEET_TYPE } from '@dealstack/shared/lib/common/business/excel';

interface Props {
	className?: string;
}

const NewJoinersAndAllocationsInvestors = ({ className }: Props) => {
	const tMipCreate = useTranslationMipCreate();
	const newJoinersAndAllocationsInvestorsController =
		useNewJoinersAndAllocationsInvestorsController();
	const {
		onTemplateDownload,
		uploadInvestorsTemplate,
		investorsSummary,
		investorsList,
		setInvestorsList,
	} = newJoinersAndAllocationsInvestorsController;

	return (
		<div className={className}>
			<InvestorsUploadInstructions />
			<NewJoinersAndAllocationsInvestorsTable
				investorsList={investorsList}
				setInvestorsList={setInvestorsList}
			/>
			<DragAndDrop
				onTemplateDownload={onTemplateDownload}
				multiple={false}
				uploadFileRequest={uploadInvestorsTemplate}
				accept={{
					[EXCEL_SPREADSHEET_TYPE]: ['.xlsx'],
				}}
				invalidTypeMessage={tMipCreate('investors.invalid_file_type')}
			/>
			{investorsSummary?.investorsCount ? (
				<NewJoinersAndAllocationsInvestorsSummary investorsSummary={investorsSummary} />
			) : null}
		</div>
	);
};

const Styled = styled(NewJoinersAndAllocationsInvestors)`
	margin-bottom: 1em;

	${Expandable}, ${NewJoinersAndAllocationsInvestorsTable} {
		margin-top: 1em;
	}

	${DragAndDrop}, ${NewJoinersAndAllocationsInvestorsSummary} {
		margin-top: 2em;
	}
`;

export { Styled as NewJoinersAndAllocationsInvestors };
